<!--  -->
<template>
  <div class="orderList">
    <van-tabs v-model="active" sticky color="#ffc053" title-active-color="#ffc053" @click="selectStatus">
      <van-tab v-for="(item,index) in tabList" :key="index" :title="item.title" :name="item.type" />
    </van-tabs>


          <van-empty
      v-if="!orderList.length>0"
      class="custom-image"
      :image="require('../../assets/icons/empty.png')"
      description="无相关订单"
    />

    <div v-else class="item-box" v-for="(item,index) in orderList" :key="index" @click="toOrder(item.out_trade_no)">
      <van-cell :title="`${item.out_trade_no}`" :value="item.state" ></van-cell>
      <van-card
        v-for="(e,eIndex) in item.CartItem"
        :key="eIndex"
        :num="e.Num"
        :price="(e.Price/100).toFixed(2)"
        :desc="`${e.OptionWeight}${e.OptionUnit}`"
        :title="e.OptionName"
        :thumb="e.OptionImage"
      />
    <div class="item-box-bottom">
          总价：
        <span class="van-card__price-currency">¥</span>
        <span class="van-card__price-integer">{{(item.Total/100).toFixed(2)}}</span>
       <van-button plain hairline type="danger" v-if="item.Status==1 || item.Status==0" size="small">取消订单</van-button>
       <van-button color="#ffc053" type="primary"  v-if="item.Status==1&&item.Ispaid==0"  size="small">去支付</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Tab, Tabs, Card, Button,Empty,Cell } from "vant";
import api from "../../api/order";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Empty.name]: Empty,
    [Cell.name]: Cell,
    [Button.name]: Button
  },
  data() {
    //这里存放数据
    return {
        active:'1',
      tabList: [
        {
          title: "全部",
          Status: "",
          IsPaid: "",
          IsReceived: ""
        },
        {
          title: "待付款",
          Status: "",
          IsPaid: "",
          IsReceived: ""
        },

        {
          title: "待发货",
          Status: "",
          IsPaid: "",
          IsReceived: ""
        },
        {
          title: "待收货",
          Status: "",
          IsPaid: "",
          IsReceived: ""
        },
        {
          title: "收货付款",
          Status: "",
          IsPaid: "",
          IsReceived: ""
        },
        {
          title: "已完成",
          Status: "",
          IsPaid: "",
          IsReceived: ""
        },
        {
          title: "已取消",
          Status: "",
          IsPaid: "",
          IsReceived: ""
        }
      ],
      orderList: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    init(status) {
        let params={
             Status: status
        }
        if(status==0){
            params={}
        }
        if(status==1){
            params={
                Status: 0,
            }
        }
        if(status==2){
            params={
                Status: 1,
            }
        }
        if(status==3){
            params={
                Status: 2,
                IsPaid: 0,
                IsReceived: 0
            }
        }
        if(status==4){
            params={
                Status: 2,
                IsPaid: 0,
                IsReceived: 1
            }
        } 
        if(status==5) {
                params={
                Status: 3
            }
        }
        status==6?params.Status='-4':''
      api.getOrderList(params).then(res => {
        console.log(res);
        if(res.status==0){
          
            res.result.forEach(item => {
                item.CartItem=JSON.parse(item.CartItem)
          switch (Number(item.Status)) {
            case 0:
              item.state = "待支付";
              break;
            case 1:
              item.state = "待发货";
              break;
            case 2:
              item.IsReceived == 0 ? (item.state = "待收货") : "";
              item.IsReceived == 1 && item.IsPaid == 0
                ? (item.state = "已收货,待付款")
                : "";
              break;
            case 3:
              item.state = "已完成";
              break;
            case -4:
              item.state = "订单取消";
              break;
          }
            });
              this.orderList=res.result
        }
      });
    },
    selectStatus(e){
        this.init(e)
    },
    toOrder(orderId){
        this.$router.push({
            name: 'order',
            query: {orderId}
        })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.orderList {
  min-height: 100vh;
  background: #f2f2f2;
  .item-box {
    margin-top: 2px;
    background: #fff;
    .item-title {
      padding: 5px 15px;
    }
  }
  .van-card {
    background: #fff;
    .van-card__title {
      font-size: 16px;
      flex: 1;
    }
    .van-card__content {
      justify-content: space-evenly;
    }
  }
  .tem-price {
    font-size: 14px;
    .total {
      font-size: 16px;
      color: red;
    }
  }
  .item-box-bottom{
      text-align: right;
      padding: 5px 15px;
      font-size: 14px;
      .van-card__price-integer{
          font-size: 16px;
      }
      .van-card__price-integer,.van-card__price-integer,.van-card__price-decimal{
          color:red
      }
      .van-button{
          margin: 0 5px;
      }
  }
}
</style>